export default __webpack_public_path__ + "static/media/Group 5798.73dccd21.svg";